import React from 'react';

import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import useEffectOnce from 'hooks/use-effect-once';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { useAuthContext } from 'state/auth';
import logger from 'utils/logger';
import { routes } from 'utils/routing';

function SignOut() {
  const { setOriginLocation, signOut, closeModalAuth } = useAuthContext();

  const router = useRouter();

  useEffectOnce(() => {
    const handleSignOut = async () => {
      try {
        await signOut();
      } catch (error) {
        logger.error({ message: 'An error occurred signing out - SignOut page', error });
      } finally {
        setOriginLocation(null);
        closeModalAuth();
        router.dismissTo(routes.base);
      }
    };

    void handleSignOut();
  });

  return (
    <Box style={styles.loaderContainer}>
      <LoyaltyLoader />
    </Box>
  );
}

export default SignOut;

const styles = StyleSheet.create({
  loaderContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
